export const filterStatuses = [
  { label: 'Active', value: 'Active' },
  { label: 'DNR', value: 'ActiveDNR' },
  { label: 'Awaiting Approval', value: 'AwaitingApproval' },
  { label: 'Cancelled', value: 'Cancelled' },
  { label: 'Expired', value: 'Expired' },
  { label: 'Inactive', value: 'Inactive' },
  { label: 'Terminating', value: 'Terminating' },
  { label: 'Terminated', value: 'Terminated' },
  { label: 'Merged', value: 'Merged' },
];

export const filterUpliftsStatuses = [
  { label: 'Applied', value: 'Applied' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Cancelled', value: 'Cancelled' },
  { label: 'Failed', value: 'Failed' },
];

export const filterUpliftsMethods = [
  { label: 'Percentage', value: 'Percentage' },
  { label: 'Unit Cost', value: 'UnitCost' },
];

export const filterPurchaseOrdersStatuses = [
  { label: 'Active', value: 'Active' },
  { label: 'Cancelled', value: 'Cancelled' },
  { label: 'Expired', value: 'Expired' },
];

export const filterOrigin = [
  { label: 'UiTool', value: 'UiTool' },
  { label: 'Document', value: 'Document' },
];

export const filterContractOrigins = [
  { label: 'Dimensions', value: 'Dimensions' },
  { label: 'CnB', value: 'CnB' },
  { label: 'OneEvo', value: 'OneEvo' },
  { label: 'Import', value: 'Import' },
  { label: 'AutoAttach', value: 'AutoAttach' },
];

export const billingStatuses = [
  { label: 'Yes', value: 'Paused' },
  { label: 'No', value: 'On' },
];

export const directDebitStatuses = [
  { label: 'Annually', value: 'Annual' },
  { label: 'Half Yearly', value: 'HalfYearly' },
  { label: 'Monthly', value: 'Monthly' },
  { label: 'Quarterly', value: 'Quarterly' },
];

export const filterBillingCycleStatuses = [
  { label: 'Active Pending', value: 'ActivePending' },
  { label: 'SO Creation Started', value: 'SoCreationStarted' },
  { label: 'SO Created', value: 'SoCreated' },
  { label: 'Excluded', value: 'Excluded' },
  { label: 'Ignored', value: 'Ignored' },
];

export const contractLinePauseStatuses = [
  { label: 'Off', value: 'On' },
  { label: 'Paused', value: 'Paused' },
  { label: 'FuturePause', value: 'FuturePause' },
];

export const filterMergeTypes = [
  { label: 'Merge By Quantity', value: 'MergeByQuantity' },
  { label: 'Merge By Unit Price', value: 'MergeByUnitPrice' },
  { label: 'No Merge', value: 'NoMerge' },
];
